import { Input, Directive, ChangeDetectorRef, inject } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

@Directive()
export abstract class BaseBtnGroupComponent implements ControlValueAccessor {
    protected readonly changeDetectorRef = inject(ChangeDetectorRef);

    public get value() {
        return this._value;
    }

    @Input()
    public set value(value: number) {
        if (this._value !== value) {
            this._value = value;
        }
    }

    protected _value: number;
    private _onChange: (value: number) => void = () => {};
    private _onTouched: () => void = () => {};

    public select(value: number): void {
        if (this.value !== value) {
            this._value = value;
            this._onChange(value);
            this._onTouched();
        }
    }

    public registerOnChange(fn: any): void {
        this._onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this._onTouched = fn;
    }

    public writeValue(value: number): void {
        if (value != null) {
            this._value = value;
            this.changeDetectorRef.markForCheck();
        }
    }
}
